<template>
  <div class="container">
    <div class="titulo text-center">
      <h2><strong>REGISTRO DE PAGOS</strong></h2>
    </div>

    <input
      v-model="searchQuery"
      type="text"
      class="form-control w-25 mb-3"
      placeholder="Buscar"
    />

    <div class="table-container">
      <table class="table table-striped table-hover table-bordered">
        <thead>
          <tr>
            <th>#</th>
            <th>Folio</th>
            <th>Nombre cliente</th>
            <th>Total R.</th>
            <th>Total P.</th>
            <th>Método de pago</th>
            <th>Fecha</th>
            <th>Estatus</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="pago in paginatedPagos" :key="pago.Id_Pago">
            <td>{{ pago.Id_Pago }}</td>
            <td>{{ pago.FolioReservacion }}</td>
            <td>{{ pago.Cliente }}</td>
            <td>{{ pago.TotalReservacion }}</td>
            <td>{{ pago.Total }}</td>
            <td>{{ pago.Metodo_Pago }}</td>
            <td>{{ pago.Fecha_Pago }}</td>
            <td>{{ pago.Estatus }}</td>
            <td>
              <button @click="editPago(pago)" class="btn btn-link">
                <i class="bi bi-pencil-square"></i>
              </button>
              <button @click="deletePago(pago.Id_Pago)" class="btn btn-link1">
                <i class="bi bi-trash-fill"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <nav aria-label="Page navigation example">
      <ul class="pagination justify-content-center">
        <li class="page-item" :class="{ disabled: currentPage === 1 }">
          <button class="page-link" @click="changePage(currentPage - 1)">Anterior</button>
        </li>
        <li
          v-for="page in totalPages"
          :key="page"
          class="page-item"
          :class="{ active: page === currentPage }"
        >
          <button class="page-link" @click="changePage(page)">{{ page }}</button>
        </li>
        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
          <button class="page-link" @click="changePage(currentPage + 1)">
            Siguiente
          </button>
        </li>
      </ul>
    </nav>

    <div v-if="isFormVisible" class="form-container mt-4">
      <h3>{{ isEditing ? "Editar Pago" : "Registrar Pago" }}</h3>
      <form @submit.prevent="isEditing ? submitEditForm() : submitForm()">
        <div class="form-group" v-if="isEditing">
          <label for="folio-pago">Folio</label>
          <input
            v-model="pago.FolioReservacion"
            type="text"
            id="folio-pago"
            class="form-control"
            readonly
          />
        </div>
        <div class="form-group" v-if="isEditing">
          <label for="nombre-pago">Nombre</label>
          <input
            v-model="pago.Cliente"
            type="text"
            id="nombre-pago"
            class="form-control"
            readonly
          />
        </div>
        <div class="form-group">
          <label for="total-pago">Total del Pago</label>
          <input v-model="pago.Total" type="number" class="form-control" required />
        </div>

        <div class="form-group">
          <label for="metodo-pago">Método de Pago</label>
          <select
            v-model="pago.Metodo_Pago"
            id="metodo-pago"
            class="form-control"
            required
          >
            <option value="Efectivo">Efectivo</option>
            <option value="Tarjeta">Tarjeta</option>
            <option value="Transferencia">Transferencia</option>
            <option value="Paypal">Paypal</option>
          </select>
        </div>

        <!-- Fecha del Pago -->
        <div class="form-group">
          <label for="fecha-pago">Fecha del Pago</label>
          <input
            v-model="pago.Fecha_Pago"
            type="datetime-local"
            id="fecha-pago"
            class="form-control"
            required
          />
        </div>

        <!-- Estatus del Pago -->
        <div class="form-group">
          <label for="estatus">Estatus</label>
          <select v-model="pago.Estatus" id="estatus" class="form-control" required>
            <option value="pendiente">Pendiente</option>
            <option value="pagado">Pagado</option>
            <option value="rechazado">Rechazado</option>
          </select>
        </div>
        <p></p>
        <button type="submit" class="btn btn-primary me-2">
          {{ isEditing ? "Actualizar" : "Guardar" }}
        </button>
        <button type="button" class="btn btn-secondary" @click="cancelForm">
          Cancelar
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      lista_pagos: [],
      pago: {
        Id_pago: null,
        Total: "",
        Metodo_Pago: "",
        IdRegistro: "",
        Fecha_Pago: "",
        Estatus: "",
      },
      isFormVisible: false,
      isEditing: false,
      searchQuery: "",
      currentPage: 1,
      itemsPerPage: 5,
    };
  },
  computed: {
    filteredPagos() {
      return this.lista_pagos.filter((pago) => {
        const searchString = `${pago.Id_pago} ${pago.Total} ${pago.Metodo_Pago} ${pago.Id_Reservacion} ${pago.Fecha_Pago} ${pago.Estatus}`.toLowerCase();
        return searchString.includes(this.searchQuery.toLowerCase());
      });
    },
    paginatedPagos() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      return this.filteredPagos.slice(startIndex, startIndex + this.itemsPerPage);
    },
    totalPages() {
      return Math.ceil(this.filteredPagos.length / this.itemsPerPage);
    },
  },
  methods: {
    async getPagos() {
      try {
        const response = await axios.get(
          this.$backendUrl+ "/index.php/pagos/lista_completa"
        );
        this.lista_pagos = response.data;
      } catch (error) {
        console.error("Error al obtener los pagos:", error);
      }
    },
    async deletePago(id) {
      if (confirm("¿Estás seguro de que deseas eliminar este pago?")) {
        try {
          await axios.post(
           this.$backendUrl+ "/index.php/pagos/borrar",
            {
              Id_Pago: id,
            }
          );
          this.getPagos();
        } catch (error) {
          console.error("Error al eliminar pago:", error);
        }
      }
    },
    async submitForm() {
      try {
        await axios.post(
          this.$backendUrl+ "/index.php/pagos/insertar",
          this.pago
        );
        this.getPagos();
        this.cancelForm();
      } catch (error) {
        console.error("Error al agregar pago:", error);
      }
    },
    async submitEditForm() {
      try {
        await axios.post(
          this.$backendUrl+ "/index.php/pagos/actualizar",
          this.pago
        );
        this.getPagos();
        this.cancelForm();
      } catch (error) {
        console.error("Error al actualizar pago:", error);
      }
    },
    showForm() {
      this.isFormVisible = true;
      this.isEditing = false;
      this.resetForm();
    },
    editPago(pago) {
      this.isEditing = true;
      this.isFormVisible = true;
      this.pago = { ...pago };
    },
    cancelForm() {
      this.isFormVisible = false;
      this.isEditing = false;
      this.resetForm();
    },
    resetForm() {
      this.pago = {
        Id_pago: null,
        Total: "",
        Metodo_Pago: "",
        IdRegistro: "",
        Fecha_Pago: "",
        Estatus: "",
      };
    },
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
  },
  mounted() {
    this.getPagos();
  },
};
</script>

<style scoped>
.table-container {
  overflow: auto;
  margin-bottom: 20px;
  text-align: center;
}

.form-container {
  margin-top: 20px;
}

.pagination .page-link {
  cursor: pointer;
  position: sticky;
}

.titulo {
  background-color: #f52349; /* Fondo rosa */
  color: white;
  font-family: "Franklin Gothic Medium", "Arial Narrow", Arial, sans-serif;
  font-size: 15px;
  padding: 15px 10px;
  margin: 5px 0 10px 0; /* Espacio superior e inferior */
}

.btn-link {
  color: #2fc1f6;
  background-color: transparent;
  font-size: 150%;
  border: none;
}

.btn-link:hover {
  color: #ce13a2;
}

.btn-link1 {
  color: red;
  background-color: transparent;
  font-size: 150%;
  border: none;
  padding-left: 10px;
}
</style>
